import { Box, Button, Heading, useMediaQuery, useStyleConfig } from '@chakra-ui/react';
import BorderBox from '../../components/Wrappers/BorderBox';
import { progressiveFormStepper } from '../../components/ProgressiveFormStepper/utils';
import { GridItem } from '@chakra-ui/react';
import React from 'react';
import RSTextarea from '../../formElements/RSTextarea';
import Text from '../../formElements/Text';
import { getUsefulVars } from '../../handlers/helpers';
import { getIndustry, openJobPosting } from './utils';
import { exitToMenu } from '../utils';
import StartTextarea from './StartTextArea';

const EditableBox = ({ props, index }) => {
  const uv = getUsefulVars(props);
  const handlers = null;
  const variant = 'wrapper';
  const styles = {};
  styles.button = useStyleConfig('Button', { variant });
  const jobSeekerData = uv.formikProps.values.jobSeekerData;
  const jobTitleQbj = props.navSections.resumes['question_parts'][1];
  const jobTitleName = 'jobSeekerData['+index+']["job_title"]';
  const jobPostingQbj = props.navSections.resumes['question_parts'][2];
  const jobPostingName = 'jobSeekerData['+index+']["job_posting"]';
  const jobPostingID = 'jp' + uv.resumeIndex;
  const isMobile = useMediaQuery('(max-width: 768px)',{ssr:false});
  return (
    <GridItem colSpan={[1, 1, 2]}>
      <BorderBox>
        <Box
          onClick={() =>
            props.stateProps.setEditableIndex(-1)
          }display='flex' justifyContent='flex-end'>
      <Button width='fit-content'>_</Button>
      </Box>
        {isMobile[0] && (
        <Box >
          <Heading>What job title will you be applying to?</Heading>
          <Box>We recommend having one resume for each job and industry.</Box>
          <Text fieldName={jobTitleName} qObj={jobTitleQbj} jobSeekerData={jobSeekerData} handlers={handlers}
                props={props} index={index} />
          <Box color="#2642bb" fontWeight='bold' textDecoration='underline' cursor="pointer" marginTop='1rem' onClick={() => openJobPosting(jobPostingID)}>+ target job posting</Box>
          <Box display="none" id={jobPostingID} >
            <Box>Please copy and paste the content of the job description below. </Box>
            <StartTextarea qObj={jobPostingQbj}
                        props={props} resumeIndex={index}
                         />
          </Box>
        </Box>
        )}

        {!isMobile[0] && (
          <Box padding="4rem 10rem 1rem 4rem">
            <Heading>What job title will you be applying to?</Heading>
            <Box>We recommend having one resume for each job and industry.</Box>
            <Text fieldName={jobTitleName} qObj={jobTitleQbj} jobSeekerData={jobSeekerData} handlers={handlers}
                  props={props} index={index} />
            <Box color="#2642bb" fontWeight='bold' textDecoration='underline' cursor="pointer" marginTop='1rem' onClick={() => openJobPosting(jobPostingID)}>+ target job posting</Box>
            <Box display="none" id={jobPostingID} >
              <Box>Please copy and paste the content of the job description below. </Box>
              <StartTextarea qObj={jobPostingQbj}
                          props={props} resumeIndex={index} />
            </Box>
          </Box>
        )}
          {isMobile[0] && (
            <Box display="flex" justifyContent="flex-end" >
            <Button
              margin="12px auto 0 auto !important"
              sx={{ ...styles.button.primary, ...styles.button.backButton }}
              onClick={() =>
                getIndustry(props, index)
              }
            >
              Continue
            </Button>
            </Box>

          )}
          {!isMobile[0] && (
            <Box display="flex" justifyContent="flex-end" paddingRight="5rem">
          <Button
            sx={{ ...styles.button.primary, ...styles.button.backButton }}

            onClick={() =>
              getIndustry(props, index)
            }
          >
            Continue
          </Button>
            </Box>
          )}
      </BorderBox>
    </GridItem>
  );
};
export default EditableBox;
/*

 */
